export abstract class AbstractViewModel<T> {
  protected constructor(public apiModel: T) {}

  protected abstract fromApiModel(): void;

  public abstract toApiModel(): T;
}
